import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { factory, Group, useProps } from "@coveord/plasma-mantine";
import { Children } from "react";
import { useEmptyStateContext } from "./EmptyStateContext.js";
var defaultProps = {
    gap: "sm"
};
export var EmptyStateActions = factory(function(_props, ref) {
    var ctx = useEmptyStateContext();
    var _ref = useProps("EmptyStateActions", defaultProps, _props), children = _ref.children, others = _object_without_properties(_ref, [
        "children"
    ]);
    var actionsCount = Children.count(children);
    return actionsCount > 0 ? /*#__PURE__*/ _jsx(Group, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles("actionsContainer")), {
        justify: ctx.variant === "small" ? "center" : "flex-start"
    }), others), {
        children: children
    })) : null;
});

//# sourceMappingURL=EmptyStateActions.js.map